module.exports = __webpack_public_path__ + "images/category_lp/brand/assessment_achievements/2_6e4288e11d23773118c5fd5ed32c82d8.jpg";